export class SupportOnboardingWidget extends HTMLElement {

	public connectedCallback(): void {
		this.innerHTML = `
				<div class="panel panel-flat">
					<div class="panel-heading">
						<h4 class="panel-title">${messages["onboardingDashboard.support.title"]}</h4>
					</div>	
					<div class="panel-body">
						${messages["onboardingDashboard.support.body"]}
					</div>
				</div>`;
	}

}
